export default "__VITE_ASSET__80990c44__"